// extracted by mini-css-extract-plugin
export var inner = "Search-module--inner--ca1f0";
export var locked = "Search-module--locked--2a412";
export var nav = "Search-module--nav--5c49b";
export var outer = "Search-module--outer--a1f9b";
export var resultsItem = "Search-module--results-item--9d24e";
export var resultsTitle = "Search-module--results-title--a26f0";